import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import './index.css';
import { api } from "../../services/api";
import Loading from "../../comum/Layout/loading.jsx";
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer/index.jsx";
import Swal from "sweetalert2";

function Cardapio() {
  const [codigoRest, setCodigoRest] = useState(0);
  const [cardapios, setCardapios] = useState([]);
  const [opcao, setOpcao] = useState("");
  const [menu, setMenu] = useState("");
  const [loading, setLoading] = useState(false);
  
  // --- NOVOS ESTADOS ---
  const [dataSelecionada, setDataSelecionada] = useState("");
  const [listaDatas, setListaDatas] = useState([]);

  const navigate = useNavigate();

  // Função para formatar data para dd/mm/aaaa
  const formatarDataBR = (date) => {
    const dia = String(date.getDate()).padStart(2, "0");
    const mes = String(date.getMonth() + 1).padStart(2, "0");
    const ano = date.getFullYear();
    return `${dia}/${mes}/${ano}`;
  };

  // 1. Gerar os próximos 7 dias (Hoje + 6)
  const gerarDatas = () => {
    const datas = [];
    for (let i = 0; i < 7; i++) {
      const d = new Date();
      d.setDate(d.getDate() + i);
      datas.push(formatarDataBR(d));
    }
    setListaDatas(datas);
    setDataSelecionada(datas[0]); // Padrão: Hoje
  };

  useEffect(() => {
    const cod = localStorage.getItem("codigorest");
    if (!cod) {
      navigate("/restaurante/login");
      return;
    }
    setCodigoRest(cod);
    gerarDatas();
    carregarCardapios(cod);
  }, []);

  // 2. Recarregar quando a data mudar
  useEffect(() => {
    if (codigoRest) carregarCardapios(codigoRest);
  }, [dataSelecionada]);

const carregarCardapios = async (cod) => {
  setLoading(true);
  try {
    // Passamos a data selecionada na query
    const response = await api.get(`/restaurante/000000/cardapio?codigo=${cod}&data=${dataSelecionada}`);
    
    if (response.data && Array.isArray(response.data)) {
      setCardapios(response.data); // Atualiza com os dados encontrados
    } else {
      setCardapios([]); // Se não for um array válido, limpa a tela
    }
  } catch (err) {
    // Se der erro 400 ou "Sem registro", limpamos a lista para não mostrar o cardápio do dia anterior
    setCardapios([]); 
    console.log("Erro ao carregar ou nenhum registro encontrado", err);
  } finally {
    setLoading(false);
  }
};

  const handleSalvar = async () => {
    if (!opcao || menu.trim() === "") {
      Swal.fire("Atenção", "Preencha a opção e o cardápio.", "warning");
      return;
    }

    const dataPost = {
      data: dataSelecionada, // 3. Data enviada via JSON no formato dd/mm/aaaa
      opcao: opcao,
      menu: menu
    };

    try {
      await api.post(`/restaurante/cardapio/${codigoRest}`, dataPost);
      Swal.fire("Sucesso", "Cardápio salvo para o dia " + dataSelecionada, "success");
      setMenu("");
      setOpcao("");
      carregarCardapios(codigoRest);
    } catch (err) {
      Swal.fire("Erro", "Erro ao salvar cardápio.", "error");
    }
  };

  const handleExcluir = async (opcaoExcluir) => {
    const confirma = await Swal.fire({
      title: "Excluir?",
      text: `Deseja excluir a opção ${opcaoExcluir} do dia ${dataSelecionada}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não"
    });

    if (confirma.isConfirmed) {
      try {
        await api.put(`/restaurante/cardapio/${codigoRest}`, {
          data: dataSelecionada,
          opcao: opcaoExcluir,
          menu: ""
        });
        carregarCardapios(codigoRest);
      } catch (err) {
        Swal.fire("Erro", "Erro ao excluir.", "error");
      }
    }
  };

  return (
    <div>
      <Menu modulo="REST" />
      <div className="container-fluid titulo">
        <h3>Cadastro de Cardápio</h3>
        {loading && <Loading />}

        <div className="card p-3 mb-4">
          <div className="row mb-3">
            {/* Seletor de Datas (7 dias) */}
            <div className="col-md-3">
              <label>Data do Cardápio</label>
              <select 
                className="form-control" 
                value={dataSelecionada}
                onChange={(e) => setDataSelecionada(e.target.value)}
              >
                {listaDatas.map(d => (
                  <option key={d} value={d}>{d === listaDatas[0] ? `${d} (Hoje)` : d}</option>
                ))}
              </select>
            </div>

            <div className="col-md-2">
              <label>Opção (1, 2 ou 3)</label>
              <select className="form-control" value={opcao} onChange={(e) => setOpcao(e.target.value)}>
                <option value="">Selecione</option>
                <option value="1">Opção 1</option>
                <option value="2">Opção 2</option>
                <option value="3">Opção 3</option>
              </select>
            </div>

            <div className="col-md-7">
              <label>Cardápio</label>
              <textarea
                className="form-control"
                value={menu}
                onChange={(e) => setMenu(e.target.value)}
                maxLength={1000}
                rows={2}
              />
            </div>
          </div>
          <button className="btn btn-success" onClick={handleSalvar}>
            Salvar para {dataSelecionada}
          </button>
        </div>

        <h4>Cardápios de {dataSelecionada}</h4>
        <table className="table table-hover table-bordered">
          <thead>
            <tr className="table-secondary" align="center">
              <th width="10%">Opção</th>
              <th>Conteúdo</th>
              <th width="20%">Ações</th>
            </tr>
          </thead>
          <tbody>
            {cardapios.length === 0 ? (
              <tr><td colSpan="3" align="center">Nenhum cardápio para este dia.</td></tr>
            ) : (
              cardapios.map((item) => (
                <tr key={item.opcao}>
                  <td align="center">{item.opcao}</td>
                  <td>{item.menu}</td>
                  <td align="center">
                    <button className="btn btn-primary btn-sm me-2" onClick={() => {setOpcao(item.opcao); setMenu(item.menu)}}>
                      Editar
                    </button>
                    <button className="btn btn-danger btn-sm" onClick={() => handleExcluir(item.opcao)}>
                      Excluir
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <Footer />
    </div>
  );
}

export default Cardapio;